import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './@core/guards/auth.guard';
import { LayoutComponent } from './containers';
import { AutoLoginComponent } from './views/auto-login/auto-login.component';
import { ChangeForgetPasswordComponent } from './views/change-forget-password/change-forget-password.component';
import { ChangePasswordComponent } from './views/change-password/change-password.component';
import { ConfigurationsComponent } from './views/configurations/configurations.component';
import { LoginComponent } from './views/login/login.component';
import { LogoutComponent } from './views/logout/logout.component';


const routes: Routes = [
  {
    path: '',
    redirectTo: 'sales',
    pathMatch: 'full',
  },

  {
    path: 'login',
    component: LoginComponent,
    data: {
      title: 'Login Page',
      id: 'LoginComponent_login'
    },
  },
  {
    path: 'autologin',
    component: AutoLoginComponent,
    data: {
      title: 'Login Page',
      id: 'LoginComponent_login'
    },
  },
  {
    path: 'logout',
    component: LogoutComponent,
    data: {
      title: 'Logout Page',
      id: 'LogoutComponent_logout'
    },
  },
  {
    path: 'config',
    component: ConfigurationsComponent,
    data: {
      title: 'Configuración',
      id: 'ConfigurationsComponent_config'
    },
    canActivate: [AuthGuard]
  },
  {
    path: 'changepassword',
    component: ChangePasswordComponent,
    data: {
      title: 'Cambiar contraseña',
      id: 'ChangePasswordComponent_changepassword'
    }
  },
  {
    path: 'changepassword/:code',
    component: ChangePasswordComponent,
    data: {
      title: 'Cambiar contraseña',
      id: 'ChangePasswordComponent_changepassword'
    }
  },
  {
    path: 'changeforgetpassword',
    component: ChangeForgetPasswordComponent,
    data: {
      title: 'Cambiar contraseña olvidada',
      id: "ChangeForgetPasswordComponent"
    }
  },
  {
    path: '',
    component: LayoutComponent,
    data: {
      title: '',
    },
    children: [
      {
        path: 'sales',
        loadChildren: () =>
          import('./views/sales/sales.module').then((m) => m.SalesModule),
        data: {
          title: 'Ventas',
          id: 'SalesModule_sales'
        }
      },
      {
        path: 'orders',
        loadChildren: () =>
          import('./views/orders/orders.module').then((m) => m.OrdersModule),
        data: {
          title: 'Ordenes',
          id: 'OrdersModule_orders'
        },
      },
      {
        path: 'invoices',
        loadChildren: () =>
          import('./views/invoices/invoices.module').then((m) => m.InvoicesModule),
        data: {
          title: 'Facturas',
          id: 'InvoicesModule_invoices'
        }
      },
      {
        path: 'returnInvoices',
        loadChildren: () => import('./views/return-invoices/return-invoices.module').then((m) => m.ReturnInvoicesModule),
        data: {
          title: 'Devolución',
          id: 'ReturnInvoicesModule_returnInvoices'
        }
      },
      {
        path: 'creditRequests',
        loadChildren: () =>
          import('./views/credit-request/credit-request.module').then(
            (m) => m.CreditRequestModule
          ),
        data: {
          title: 'Solicitudes de credito',
          id: 'CreditRequestModule_creditRequestTracker'
        },
      },
      {
        path: 'customer',
        loadChildren: () =>
          import('./views/customers/customers.module').then(
            (m) => m.CustomersModule
          ),
        data: {
          title: 'Clientes',
          id: 'CustomersModule_customer'
        },
      },
      {
        path: 'products',
        loadChildren: () => import('./views/products/products.module').then(m => m.ProductsModule),
        data: {
          title: 'Productos',
          id: 'ProductsModule_products'
        }
      },
      // {
      //   path: 'changepassword',
      //   component: ChangePasswordComponent,
      //   data: {
      //     title: 'Cambiar contraseña',
      //     id: 'ChangePasswordComponent_changepassword'
      //   }
      // },
      {
        path: 'equipmentRegistrationTicket',
        loadChildren: () =>
          import('./views/equipment-registration-ticket/equipment-registration-ticket.module').then((m) => m.EquipmentRegistrationTicketModule),
        data: {
          title: 'Gestión de Matrículas',
          id: 'EquipmentRegistrationTicketModule_equipmentRegistrationTicket'
        }
      },
      {
        path: 'biometry',
        loadChildren: () => import('./views/biometry/biometry.module').then((m) => m.BiometryModule),
        data: {
          title: 'Biometría',
          id: "BiometryModule_biometry"
        }
      },
      {
        path: 'voidPayment',
        loadChildren: () => import('./views/void-payment/void-payment.module').then((m) => m.VoidPaymentModule),
        data: {
          title: 'Anulación de Pagos',
          id: "VoidPaymentModule_voidPayment"
        }
      },
      {
        path: 'deliveryTicket',
        loadChildren: () => import('./views/delivery-ticket/delivery-ticket.module').then((m) => m.DeliveryTicketModule),
        data: {
          title: "Envio a Domicilio",
          id: 'DeliveryTicketModule_deliveryTicket'
        }
      },
      {
        path: 'recollection',
        loadChildren: () => import('./views/contracts-recollection/contracts-recollection.module').then((m) => m.ContractsRecollectionModule),
        data: {
          title: "Recaudo",
          id: 'ContractsRecollection_contractsRecollection'
        }
      },
      {
        path: 'salesforceTransactions',
        loadChildren: () => import('./views/replicate-information/replicate-information.module').then(m => m.ReplicateInformationModule),
        data: {
          title: 'Transacciones Salesforce',
          id: 'ReplicateInformationComponent_salesforceTransactions'
        }
      },
      {
        path: 'giftcards',
        loadChildren: () => import('./views/giftcards/giftcards.module').then(m => m.GiftcardsModule),
        data: {
          title: 'Giftcards',
          id: 'Giftcards_giftcards'
        }
      },
      {
        path: 'registerclosing',
        loadChildren: () => import('./views/register-closing/register-closing.module').then(m => m.RegisterClosingModule),
        data: {
          title: 'Cierre de cajas',
          id: 'RegisterClosingModule_registerclosing'
        }
      },
      {
        path: 'wedding',
        loadChildren: () => import('./views/wedding/wedding.module').then(m => m.WeddingModule),
        data: {
          title: 'Bodas',
          id: 'WeddingModule_wedding'
        }
      },
      {
        path: "cashLoans",
        loadChildren: () => import('./views/cash-loans/cash-loans.module').then(m => m.CashLoansModule),
        data: {
          title: "Préstamos en efectivo",
          id: "CashLoansModule_cashLoans"
        }
      },
      {
        path: "reimbursements",
        loadChildren: () => import('./views/reimbursement/reimbursement.module').then(m => m.ReimbursementModule),
        data: {
          title: "Reembolso Caja Chica",
          id: "ReimbursementModule_reimbursements"
        },
      },
      {
        path: 'deliveryOrders',
        loadChildren: () => import("./views/order-checklist/order-checklist.module").then(m => m.OrderChecklistModule),
        data: {
          title: "Ordenes de entrega",
          id: 'DeliveryOrdersModule_deliveryOrders',
        }
      },
      {
        path: "cashLoans",
        loadChildren: () => import('./views/cash-loans/cash-loans.module').then(m => m.CashLoansModule),
        data: {
          title: "Préstamos en efectivo",
          id: "CashLoansModule_cashLoans"
        }
      },
      {
        path: 'cashDepositMonitor',
        loadChildren: () => import("./views/cash-deposit-monitor/cash-deposit-monitor.module").then(m => m.CashDepositMonitorModule),
        data: {
          title: "Monitor de depositos",
          id: 'CashDepositMonitorModule_cashDepositMonitor',
        }
      }
    ],
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
